import type { ChangeEvent } from "react";
import { LOCALE_NAMES, SUPPORTED_LOCALES, useI18n } from "../i18n";
import type { Locale } from "../i18n";

/**
 * A plain `<select>`, deliberately. It is the one control on the page a
 * reader may need *before* they can read anything else, so it inherits the
 * platform's own keyboard handling, screen-reader labelling and touch
 * behaviour rather than a bespoke menu's.
 *
 * Each language names itself — see LOCALE_NAMES.
 */
export function LanguagePicker() {
  const { locale, setLocale, m } = useI18n();

  function handleChange(event: ChangeEvent<HTMLSelectElement>) {
    setLocale(event.target.value as Locale);
  }

  return (
    <select className="lang-picker" aria-label={m.language.label} value={locale} onChange={handleChange}>
      {SUPPORTED_LOCALES.map((option) => (
        <option key={option} value={option}>
          {LOCALE_NAMES[option]}
        </option>
      ))}
    </select>
  );
}
